import React from "react"
import styles from './games-menu.module.css';
import { useNavigate } from "react-router-dom"

type Props = {}

export const GamesMenu = (props: Props) => {

  const navigate = useNavigate();

  const naviageToGames = ()=>{
    navigate("/games-home");
  }

  return (
    <div className={"cursor-pointer " + styles.menuItem} onClick={naviageToGames}>
      <div className={"d-flex justify-content-center mt-3"}>
        <i className="fas fa-gamepad font-size-20"></i>
      </div>
      <div className={"d-flex justify-content-center font-size-12"}>
        Games
      </div>
    </div>
  )
}